import { render, staticRenderFns } from "./ProntoAtendimentoComponente.vue?vue&type=template&id=32de5090&scoped=true"
import script from "./ProntoAtendimentoComponente.vue?vue&type=script&lang=js"
export * from "./ProntoAtendimentoComponente.vue?vue&type=script&lang=js"
import style0 from "./ProntoAtendimentoComponente.vue?vue&type=style&index=0&id=32de5090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de5090",
  null
  
)

export default component.exports